import * as React from 'react';
export const peoplesunitedSvg = React.forwardRef(function peoplesunitedSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#1764A3',
        d: 'M0 0h32v32H0z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#FFF',
        d: 'M27.85 12.68a1.7 1.7 0 0 1-.49 1.57c-.4.32-.82.13-.95-.42-.12-.56.1-1.25.5-1.57.4-.32.82-.12.94.42zm-14.13-3.7a19.55 19.55 0 0 0-7.47 5.49h-.42a25.34 25.34 0 0 1 7.5-6.27c7.07-3.81 13.35-2.4 14.35 3.13-.44-.42-1.12 0-1.43.95-1.2-4.53-6.5-5.78-12.53-3.3zm4.6 2.43c1.3 0 2.94.82 2.5 2.94-.46 2.28-1.68 2.92-3.74 2.92h-1.89l-.71 3.32h-2.62l1.97-9.18h4.48zm-.46 3.07c-.1.5-.29.75-.96.75l-1.28-.01.32-1.52h1.16c.58 0 .87.28.76.78zm8.32 3.24-.06.55a25.9 25.9 0 0 1-7.18 5.54c-7.4 3.83-13.88 2.4-14.56-3.4-.13-1.14-.02-2.37.29-3.64.3.31.75.45 1.23.38-1.54 6.36 4.86 9.06 12.69 5.86 2.95-1.2 5.6-3.1 7.59-5.3z',
      }),
    ),
  );
});
peoplesunitedSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  viewBox: '0 0 32 32',
};
export var peoplesunited = {
  category: 'brand',
  colorable: false,
  name: 'peoplesunited',
  svg: peoplesunitedSvg,
};
